import { render } from "./purchase-report.vue?vue&type=template&id=e49e7ff6&scoped=true"
import script from "./purchase-report.vue?vue&type=script&lang=js"
export * from "./purchase-report.vue?vue&type=script&lang=js"

import "./purchase-report.vue?vue&type=style&index=0&id=e49e7ff6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e49e7ff6"]])

export default __exports__